// src/pages/Home.jsx
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay, Pagination } from 'swiper/modules';
import { motion } from 'framer-motion';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import HomeHero from './HomeHero';

// === IMAGES ===
import sigiriya from '../assets/Japan/images (14).jpeg';
import udawalawa from '../assets/Japan/images (3).jpeg';
import ella from '../assets/Japan/images (15).jpeg';
import mirissa from '../assets/Japan/images (16).jpeg';
import nuwaraeliya from '../assets/Japan/thumb_11df8824-b80e-475a-8f63-37d78f3e92b7.jpg';
import kandy from '../assets/Japan/images (17).jpeg';
import galle from '../assets/Japan/a0005331_parts_654d79787fe25.webp';
import Yala from '../assets/Japan/20231019_135309_f5a176c0_w1920.webp';
import anuradhapura from '../assets/Japan/images (18).jpeg';
import polonnaruwa from '../assets/Japan/images (19).jpeg';

import esalaPeraharaImage from '../assets/Japan/images (21).jpeg';
import safariImage from '../assets/Japan/caption (1).jpg';
import elephantRideFeatureImage from '../assets/Japan/fuji-mountain-in-autumn-822273028-5a6a8a9c3418c600363958d3 (1).jpg';
import label1 from '../assets/pick/36.jpg';
import label2 from '../assets/pick2/yala/LK710A2062-02-E.webp';
import tourProgrammeImage1 from '../assets/Japan/content_01_5ce63a8d72.jpg';
import tourProgrammeImage2 from '../assets/Japan/hakone-loop_7.jpg';
import tourProgrammeImage3 from '../assets/Japan/images (16).jpeg';
import tourProgrammeImage4 from '../assets/Japan/811ddd7d-2a71-4a17-a7c9-b5689d5be120.webp';
import tourProgrammeImage5 from '../assets/Japan/811ddd7d-2a71-4a17-a7c9-b5689d5be120.webp';



import aboutContactImage from '../assets/Japan/images (4).jpeg';

// Famous Tours Images
import benthotaImage from '../assets/Japan/images (3).jpeg';
import polgampalaImage from '../assets/Japan/osaka.jpg';
import galleToursImage from '../assets/Japan/images (16).jpeg';
import sigiriyaToursImage from '../assets/Japan/images (20).jpeg';


import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// Gallery Images
import gallery1 from '../assets/Japan/iloveimg-converted/IMG_2677.jpg';
import gallery2 from '../assets/Japan/iloveimg-converted/IMG_2679.jpg';
import gallery3 from '../assets/Japan/iloveimg-converted (1)/IMG_2794.jpg';
import gallery4 from '../assets/Japan/iloveimg-converted (1)/IMG_2989.jpg';
import gallery5 from '../assets/Japan/iloveimg-converted (1)/IMG_3011.jpg';
import gallery6 from '../assets/Japan/iloveimg-converted (1)/IMG_2813.jpg';
import gallery7 from '../assets/Japan/iloveimg-converted (1)/IMG_2890.jpg';
import gallery8 from '../assets/Japan/images (10).jpeg';
import gallery9 from '../assets/Japan/1_Miyajima.jpg';
import gallery10 from '../assets/Japan/100462016.jpeg';
import gallery11 from '../assets/Japan/iloveimg-converted (1)/IMG_2850.jpg';
import gallery12 from '../assets/Japan/images (16).jpeg';
import gallery13 from '../assets/Japan/capodanno-giapponese-tokyo.webp';
import gallery14 from '../assets/Japan/iloveimg-converted (1)/IMG_2947.jpg';
import gallery15 from '../assets/Japan/hanami-s1279538656.jpg';
import gallery16 from '../assets/Japan/Osaka-Castle-Spring-2.jpg';
import gallery17 from '../assets/Japan/images (4).jpeg';
import gallery18 from '../assets/Japan/hakone-loop_7.jpg';
import gallery19 from '../assets/Japan/caption.jpg';
import gallery20 from '../assets/Japan/IMG_3017.jpg';
import gallery21 from '../assets/Japan/1.jpg';
import gallery22 from '../assets/Japan/IGI_6551.webp';
import gallery23 from '../assets/Japan/4100_11.jpg';
import gallery24 from '../assets/Japan/a0005331_parts_654d79787fe25.webp';
import gallery25 from '../assets/Japan/Nachi-Japan-Outdoor-Adventures.jpg';
import gallery26 from '../assets/Japan/HakonePrivateCharteredDayTour(FromTokyo).jpg';
import gallery27 from '../assets/Japan/iloveimg-converted (1)/IMG_2985.jpg';
import gallery28 from '../assets/Japan/images (7).jpeg';


// === MOTION VARIANTS ===
const sectionVariants = { hidden: { opacity: 0, y: 60, scale: 0.94 }, visible: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.9, ease: "easeOut" } } };
const textVariants = { hidden: { opacity: 0, y: 25 }, visible: { opacity: 1, y: 0, transition: { duration: 0.7 } } };
const scaleUp = { hidden: { opacity: 0, scale: 0.88 }, visible: { opacity: 1, scale: 1, transition: { duration: 0.8 } } };
const staggerContainer = { hidden: { opacity: 0 }, show: { opacity: 1, transition: { staggerChildren: 0.18 } } };
const accordionItem = { hidden: { opacity: 0, y: 12 }, show: { opacity: 1, y: 0, transition: { duration: 0.45 } } };

// === SLICK SETTINGS ===
const galleryMobileSettings = {
    dots: false, infinite: true, speed: 500, slidesToShow: 1, slidesToScroll: 1,
    autoplay: true, autoplaySpeed: 3000, arrows: false,

    customPaging: () => (<div className="w-2 h-2 rounded-full bg-white/30 mx-1 transition-all duration-300 hover:bg-[#7FDBFF]" />)
};

const tourProgrammeSliderSettings = {
    dots: false,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2800,
    arrows: false,
    rtl: true,
};

const fadeInUp = {
    hidden: { opacity: 0, y: 40 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } }
};
const cardHover = {
    rest: { scale: 1, y: 0 },
    hover: { scale: 1.04, y: -12, transition: { duration: 0.4 } }
};


// === TITLE COMPONENT ===
const SectionTitle = ({ mainTitle, subTitle }) => (
    <div className="flex flex-col items-center text-center">
        <p className="mb-4 text-sm font-semibold uppercase tracking-[0.35em] text-[#f7d774]">
            Curated Journey
        </p>
        <h2 className="font-serif text-[2.5rem] font-semibold uppercase tracking-[0.02em] text-[#7fd3ff] md:text-4xl lg:text-5xl xl:text-6xl">
            {mainTitle}
        </h2>
        <p className="mt-3 max-w-3xl text-sm leading-7 text-white/80 md:text-base lg:mt-4 lg:text-lg">{subTitle}</p>
        <div className="mt-5 flex w-full max-w-md gap-2">
            <div className="h-[3px] flex-1 rounded-full bg-[#f7d774]"></div>
            <div className="h-[3px] flex-1 rounded-full bg-[#7fd3ff]"></div>
        </div>
    </div>
);

const Home = () => {
    const { t } = useTranslation('home');

    const [activeIndex, setActiveIndex] = useState(null);
    const [selectedGalleryImage, setSelectedGalleryImage] = useState(null);

    const toggleService = (index) => setActiveIndex(activeIndex === index ? null : index);
    const openGalleryImage = (src, alt) => {
        if (src) {
            setSelectedGalleryImage({ src, alt });
        }
    };
    const closeGalleryImage = () => setSelectedGalleryImage(null);

    // Load Elfsight widget
    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://elfsightcdn.com/platform.js';
        script.async = true;
        document.body.appendChild(script);
        return () => { if (document.body.contains(script)) document.body.removeChild(script); };
    }, []);

    useEffect(() => {
        const gallerySection = document.getElementById('gallery-section');
        if (!gallerySection) return;

        const handleGalleryClick = (event) => {
            const imageElement = event.target.closest('img');
            if (!imageElement) return;

            const src = imageElement.getAttribute('src');
            const alt = imageElement.getAttribute('alt') || 'Gallery image';
            openGalleryImage(src, alt);
        };

        gallerySection.addEventListener('click', handleGalleryClick);
        return () => gallerySection.removeEventListener('click', handleGalleryClick);
    }, []);

    // === TRANSLATED DATA ===
    const destinations = [
        {
            label: t('recommendations.tokyo.label'),
            name: t('recommendations.tokyo.name'),
            image: sigiriya
        },
        {
            label: t('recommendations.mountFuji.label'),
            name: t('recommendations.mountFuji.name'),
            image: udawalawa
        },
        {
            label: t('recommendations.kyoto.label'),
            name: t('recommendations.kyoto.name'),
            image: ella
        },
        {
            label: t('recommendations.osaka.label'),
            name: t('recommendations.osaka.name'),
            image: mirissa
        },
        {
            label: t('recommendations.nara.label'),
            name: t('recommendations.nara.name'),
            image: nuwaraeliya
        },
        {
            label: t('recommendations.hakone.label'),
            name: t('recommendations.hakone.name'),
            image: kandy
        },
        {
            label: t('recommendations.nikko.label'),
            name: t('recommendations.nikko.name'),
            image: galle
        },
        {
            label: t('recommendations.shirakawago.label'),
            name: t('recommendations.shirakawago.name'),
            image: Yala
        },
        {
            label: t('recommendations.arashiyama.label'),
            name: t('recommendations.arashiyama.name'),
            image: anuradhapura
        },
        {
            label: t('recommendations.himeji.label'),
            name: t('recommendations.himeji.name'),
            image: polonnaruwa
        },
    ];

    const excursions = [
        { title: t('excursions.oneDay.title'), des: t('excursions.oneDay.des') },
        { title: t('excursions.twoDays.title'), des: t('excursions.twoDays.des') },
        { title: t('excursions.threeDays.title'), des: t('excursions.threeDays.des') },
        { title: t('excursions.fourDays.title'), des: t('excursions.fourDays.des') },
        { title: t('excursions.fiveDays.title'), des: t('excursions.fiveDays.des') },
    ];

    const tourProgrammeImages = [
        tourProgrammeImage1,
        tourProgrammeImage2,
        tourProgrammeImage3,
        tourProgrammeImage4,
        tourProgrammeImage5,
    ];



    const featuredExperiences = [
        {
            h2: t('featured.elephantRide.h2'),
            h3: t('featured.elephantRide.h3'),
            paragraph: t('featured.elephantRide.paragraph'),
            image: elephantRideFeatureImage,
            label: null,
            buttonText: t('featured.elephantRide.button'),
            link: '/elephant-ride',
            buttonGradient: 'linear-gradient(to right, #7FDBFF, #40c4e6)'
        },
        {
            h2: t('featured.perahera.h2'),
            h3: t('featured.perahera.h3'),
            h4: t('featured.perahera.h4'),
            paragraph: t('featured.perahera.paragraph'),
            image: esalaPeraharaImage,
            label: label1,
            buttonText: t('featured.perahera.button'),
            link: '/events',
            buttonGradient: 'linear-gradient(to right, #0074D9, #005fae)'
        },
        {
            h2: t('featured.safari.h2'),
            h3: t('featured.safari.h3'),
            paragraph: t('featured.safari.paragraph'),
            image: safariImage,
            label: label2,
            buttonText: t('featured.safari.button'),
            link: '/gallery',
            buttonGradient: 'linear-gradient(to right, #7FDBFF, #40c4e6)'
        },
    ];

    const galleryImages = [
        { src: gallery1, alt: t('gallery.alt1') }, { src: gallery2, alt: t('gallery.alt2') }, { src: gallery3, alt: t('gallery.alt3') },
        { src: gallery4, alt: t('gallery.alt4') }, { src: gallery5, alt: t('gallery.alt5') }, { src: gallery6, alt: t('gallery.alt6') },
        { src: gallery7, alt: t('gallery.alt7') }, { src: gallery8, alt: t('gallery.alt8') }, { src: gallery9, alt: t('gallery.alt9') },
        { src: gallery10, alt: t('gallery.alt10') }, { src: gallery11, alt: t('gallery.alt11') }, { src: gallery12, alt: t('gallery.alt12') },
        { src: gallery13, alt: t('gallery.alt13') }, { src: gallery14, alt: t('gallery.alt14') }, { src: gallery15, alt: t('gallery.alt15') },
        { src: gallery16, alt: t('gallery.alt16') }, { src: gallery17, alt: t('gallery.alt17') }, { src: gallery18, alt: t('gallery.alt18') },
        { src: gallery19, alt: t('gallery.alt19') }, { src: gallery20, alt: t('gallery.alt20') }, { src: gallery21, alt: t('gallery.alt21') },
        { src: gallery22, alt: t('gallery.alt22') }, { src: gallery23, alt: t('gallery.alt23') }, { src: gallery24, alt: t('gallery.alt24') },
        { src: gallery25, alt: t('gallery.alt25') }, { src: gallery26, alt: t('gallery.alt26') }, { src: gallery27, alt: t('gallery.alt27') },
        { src: gallery28, alt: t('gallery.alt28') },
    ];

    return (
        <div className="min-h-screen bg-[#07111f] text-white">
            {/* HERO */}
            <HomeHero />

            {/* CURATED DESTINATIONS */}
            <motion.section
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={fadeInUp}
                className="py-16 md:py-24"
            >
                <div className="container mx-auto px-5 md:px-8 lg:px-12">
                    <SectionTitle
                        mainTitle={t('sections.recommendations.title')}
                        subTitle={t('sections.recommendations.subtitle')}
                    />

                    <Swiper
                        modules={[Navigation, Autoplay, Pagination]}
                        spaceBetween={20}
                        slidesPerView={1.1}
                        centeredSlides={true}
                        loop={true}
                        autoplay={{ delay: 4500, disableOnInteraction: false }}
                        pagination={{ clickable: true }}
                        navigation={true}
                        breakpoints={{
                            640: { slidesPerView: 2, centeredSlides: false },
                            768: { slidesPerView: 2.5 },
                            1024: { slidesPerView: 3.5 },
                            1280: { slidesPerView: 4.2 },
                        }}
                        className="pb-12 !px-4 mt-10"
                    >
                        {destinations.map((dest, idx) => (
                            <SwiperSlide key={idx}>
                                <motion.div
                                    variants={cardHover}
                                    initial="rest"
                                    whileHover="hover"
                                    className="group relative h-[460px] cursor-pointer overflow-hidden rounded-[1.5rem] border border-white/10 bg-[#0f1d33] shadow-[0_20px_50px_rgba(0,0,0,0.25)] md:h-[520px]"
                                >
                                    <img
                                        src={dest.image}
                                        alt={dest.name}
                                        className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-[#07111f]/95 via-[#07111f]/35 to-transparent opacity-80 transition-opacity duration-500 group-hover:opacity-100" />
                                    <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                                        <h3 className="text-3xl font-semibold text-[#7fd3ff] drop-shadow-lg md:text-4xl lg:text-5xl">
                                            {dest.label}
                                        </h3>
                                        <p className="mt-2 text-lg font-medium text-white/90 drop-shadow md:text-xl">
                                            {dest.name}
                                        </p>
                                    </div>
                                </motion.div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </motion.section>

            {/* GOOGLE REVIEWS */}
            <motion.section
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={fadeInUp}
                className="bg-gradient-to-b from-[#0b1527] to-[#07111f] py-16 md:py-24"
            >
                <div className="container mx-auto px-5 md:px-8 lg:px-12">
                    <motion.div variants={textVariants} className="mb-12 text-center">
                        <motion.div className="mb-6 flex items-center justify-center gap-6">
                            <div className="h-px w-[50px] bg-gradient-to-r from-[#f7d774] to-transparent"></div>
                            <h2 className="font-serif text-4xl font-semibold uppercase tracking-[0.02em] text-[#7fd3ff] md:text-5xl lg:text-6xl">
                                What Our Guests Say
                            </h2>
                            <div className="h-px w-[50px] bg-gradient-to-l from-[#f7d774] to-transparent"></div>
                        </motion.div>
                        <motion.p variants={textVariants} className="mx-auto mt-4 max-w-2xl text-base text-white/80 md:text-lg">
                            Read authentic reviews from travelers who experienced Sonic Tours
                        </motion.p>
                        <motion.div variants={textVariants} className="mt-6 flex justify-center gap-3">
                            <div className="h-1.5 w-12 rounded-full bg-[#7fd3ff]"></div>
                            <div className="h-1.5 w-12 rounded-full bg-[#f7d774]"></div>
                            <div className="h-1.5 w-12 rounded-full bg-[#7fd3ff]"></div>
                        </motion.div>
                    </motion.div>

                    <motion.div
                        variants={textVariants}
                        className="mx-auto max-w-4xl overflow-hidden rounded-[1.5rem] border border-white/10 bg-[#0f1d33] p-6 shadow-[0_20px_50px_rgba(0,0,0,0.25)] md:p-8"
                    >
                        <div className="w-full" style={{ minHeight: '420px' }}>
                            <div className="elfsight-app-b59d37c3-85e6-41ce-8141-5585d8516121" data-elfsight-app-lazy></div>
                        </div>
                    </motion.div>
                </div>
            </motion.section>

            {/* TOUR PROGRAMMES */}
            <motion.section initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={sectionVariants} className="">
                <div className="container mx-auto px-4 font-redHatDisplay">
                    <motion.div variants={textVariants} className="flex items-center gap-6">
                        <div className="h-px w-[50px] bg-gradient-to-r from-[#f7d774] to-transparent"></div>
                        <h1 className="font-serif text-[18px] font-semibold uppercase tracking-[0.02em] text-[#7fd3ff] md:text-[32px] lg:text-[44px]">{t('sections.excursions.title')}</h1>
                    </motion.div>
                    <motion.div variants={textVariants} className="mt-3 justify-between lg:flex">
                        <p className="w-full text-white/80 lg:w-[50%] lg:text-lg">{t('sections.excursions.desc')}</p>

                    </motion.div>
                    <motion.div variants={textVariants} className="my-8 h-px w-full bg-white/10 lg:my-14"></motion.div>
                    <div className="gap-16 lg:flex">
                        <motion.div variants={scaleUp} className="relative mb-12 h-[420px] w-full overflow-hidden rounded-[1.25rem] shadow-2xl lg:mb-0 lg:h-[580px] lg:w-[50%]">
                            <Slider {...tourProgrammeSliderSettings}>
                                {tourProgrammeImages.map((image, index) => (
                                    <div key={index} className="h-[420px] lg:h-[580px]">
                                        <img src={image} alt={`Japan tour programme ${index + 1}`} className="h-full w-full object-cover" loading="lazy" />
                                    </div>
                                ))}
                            </Slider>
                        </motion.div>
                        <motion.div variants={staggerContainer} initial="hidden" whileInView="show" viewport={{ once: true }} className="space-y-5 lg:w-[60%]">
                            {excursions.map((service, i) => (
                                <motion.div key={i} variants={accordionItem} onClick={() => toggleService(i)} className="cursor-pointer rounded-[1.25rem] border border-white/10 bg-[#0f1d33]/90 p-5 shadow-[0_20px_50px_rgba(0,0,0,0.25)] backdrop-blur-sm transition-all hover:border-[#7fd3ff]/50 hover:bg-[#0f1d33]">
                                    <h2 className="flex items-center justify-between text-lg font-semibold lg:text-xl">
                                        {service.title}
                                        <span className="text-3xl font-thin text-[#f7d774]">{activeIndex === i ? '−' : '+'}</span>
                                    </h2>
                                    {activeIndex === i && <p className="mt-3 text-sm leading-7 text-white/80 lg:text-base">{service.des}</p>}
                                </motion.div>
                            ))}
                        </motion.div>
                    </div>
                </div>
            </motion.section>

            {/* OUR SIGNIFICANT FAMOUS TOURS */}
            <section initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={sectionVariants} className="bg-gradient-to-b from-[#0b1527] to-[#07111f] py-16 md:py-24">
                <div className="container mx-auto px-5 md:px-8 lg:px-12">
                    {/* Section Header */}
                    <motion.div className="text-center mb-16">
                        <motion.div variants={textVariants} className="mb-6 flex items-center justify-center gap-6">
                            <div className="h-px w-[50px] bg-gradient-to-r from-[#f7d774] to-transparent"></div>
                            <h2 className="font-serif text-4xl font-semibold uppercase tracking-[0.02em] text-[#7fd3ff] md:text-5xl lg:text-6xl">
                                {t('famousTours.title')}
                            </h2>
                            <div className="h-px w-[50px] bg-gradient-to-l from-[#f7d774] to-transparent"></div>
                        </motion.div>
                        <motion.p variants={textVariants} className="mx-auto mt-4 max-w-2xl text-base text-white/80 md:text-lg">
                            {t('famousTours.subtitle')}
                        </motion.p>
                        <motion.div variants={textVariants} className="mt-6 flex justify-center gap-3">
                            <div className="h-1.5 w-12 bg-[#7FDBFF] rounded-full"></div>
                            <div className="h-1.5 w-12 bg-[#0074D9] rounded-full"></div>
                            <div className="h-1.5 w-12 bg-[#7FDBFF] rounded-full"></div>
                        </motion.div>
                    </motion.div>

                    {/* Tours Grid */}
                    <div
                        variants={staggerContainer}
                        initial="hidden"
                        whileInView="show"
                        viewport={{ once: true, amount: 0.2 }}
                        className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8"
                    >
                        {/* Benthota River Safari */}
                        <motion.div
                            variants={accordionItem}
                            whileHover={{ y: -15, scale: 1.05 }}
                            transition={{ type: "spring", stiffness: 300, damping: 20 }}
                            className="group relative overflow-hidden rounded-[1.5rem] border border-white/10 bg-[#0f1d33] shadow-[0_20px_50px_rgba(0,0,0,0.25)] transition-all duration-400 hover:border-[#7fd3ff]/50"
                        >
                            <div className="relative h-64 overflow-hidden md:h-72">
                                <img src={benthotaImage} alt="Benthota" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110" />
                                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/60 transition-all duration-500 group-hover:to-black/80"></div>
                            </div>
                            <div className="p-6">
                                <h3 className="mb-3 text-xl font-semibold text-[#7fd3ff] transition-colors group-hover:text-white md:text-2xl">
                                    {t('famousTours.tours.benthotaRiverSafari.title')}
                                </h3>
                                <div className="mb-4 h-1 w-12 rounded-full bg-gradient-to-r from-[#f7d774] to-[#7fd3ff]"></div>
                                <div
                                    className="text-sm leading-relaxed text-white/80 md:text-base"
                                    dangerouslySetInnerHTML={{ __html: t('famousTours.tours.benthotaRiverSafari.description') }}
                                />
                                <a href="https://wa.me/94767584594?text=Hello%20Sonic%20Tours!%20I%20want%20to%20book%20a%20Benthota%20River%20Safari%20tour." target="_blank" rel="noopener noreferrer" className="mt-6 block">
                                    <button className="w-full cursor-pointer rounded-full bg-gradient-to-r from-[#7fd3ff] to-[#f7d774] py-2.5 font-semibold text-white transition-all group-hover:scale-105 hover:opacity-90">
                                        {t('famousTours.bookNow')}
                                    </button>
                                </a>
                            </div>
                        </motion.div>

                        {/* Polgampala Water Pool Tour */}
                        <motion.div
                            variants={accordionItem}
                            whileHover={{ y: -15, scale: 1.05 }}
                            transition={{ type: "spring", stiffness: 300, damping: 20 }}
                            className="group relative overflow-hidden rounded-[1.5rem] border border-white/10 bg-[#0f1d33] shadow-[0_20px_50px_rgba(0,0,0,0.25)] transition-all duration-400 hover:border-[#7fd3ff]/50"
                        >
                            <div className="relative h-64 overflow-hidden md:h-72">
                                <img src={polgampalaImage} alt="Polgampala" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110" />
                                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/60 transition-all duration-500 group-hover:to-black/80"></div>
                            </div>
                            <div className="p-6">
                                <h3 className="mb-3 text-xl font-semibold text-[#7fd3ff] transition-colors group-hover:text-white md:text-2xl">
                                    {t('famousTours.tours.polgampalaWaterPool.title')}
                                </h3>
                                <div className="mb-4 h-1 w-12 rounded-full bg-gradient-to-r from-[#f7d774] to-[#7fd3ff]"></div>
                                <div
                                    className="text-sm leading-relaxed text-white/80 md:text-base"
                                    dangerouslySetInnerHTML={{ __html: t('famousTours.tours.polgampalaWaterPool.description') }}
                                />
                                <a href="https://wa.me/94767584594?text=Hello%20Sonic%20Tours!%20I%20want%20to%20book%20a%20Polgampala%20Water%20Pool%20tour." target="_blank" rel="noopener noreferrer" className="mt-6 block">
                                    <button className="w-full cursor-pointer rounded-full bg-gradient-to-r from-[#7fd3ff] to-[#f7d774] py-2.5 font-semibold text-white transition-all group-hover:scale-105 hover:opacity-90">
                                        {t('famousTours.bookNow')}
                                    </button>
                                </a>
                            </div>
                        </motion.div>

                        {/* Galle Tour */}
                        <motion.div
                            variants={accordionItem}
                            whileHover={{ y: -15, scale: 1.05 }}
                            transition={{ type: "spring", stiffness: 300, damping: 20 }}
                            className="group relative overflow-hidden rounded-[1.5rem] border border-white/10 bg-[#0f1d33] shadow-[0_20px_50px_rgba(0,0,0,0.25)] transition-all duration-400 hover:border-[#7fd3ff]/50"
                        >
                            <div className="relative h-64 overflow-hidden md:h-72">
                                <img src={galleToursImage} alt="Galle" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110" />
                                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/60 transition-all duration-500 group-hover:to-black/80"></div>
                            </div>
                            <div className="p-6">
                                <h3 className="mb-3 text-xl font-semibold text-[#7fd3ff] transition-colors group-hover:text-white md:text-2xl">
                                    {t('famousTours.tours.galleTour.title')}
                                </h3>
                                <div className="mb-4 h-1 w-12 rounded-full bg-gradient-to-r from-[#f7d774] to-[#7fd3ff]"></div>
                                <div
                                    className="text-sm leading-relaxed text-white/80 md:text-base"
                                    dangerouslySetInnerHTML={{ __html: t('famousTours.tours.galleTour.description') }}
                                />
                                <a href="https://wa.me/94767584594?text=Hello%20Sonic%20Tours!%20I%20want%20to%20book%20a%20Galle%20tour." target="_blank" rel="noopener noreferrer" className="mt-6 block">
                                    <button className="w-full cursor-pointer rounded-full bg-gradient-to-r from-[#7fd3ff] to-[#f7d774] py-2.5 font-semibold text-white transition-all group-hover:scale-105 hover:opacity-90">
                                        {t('famousTours.bookNow')}
                                    </button>
                                </a>
                            </div>
                        </motion.div>

                        {/* Sigiriya Tour */}
                        <motion.div
                            variants={accordionItem}
                            whileHover={{ y: -15, scale: 1.05 }}
                            transition={{ type: "spring", stiffness: 300, damping: 20 }}
                            className="group relative overflow-hidden rounded-[1.5rem] border border-white/10 bg-[#0f1d33] shadow-[0_20px_50px_rgba(0,0,0,0.25)] transition-all duration-400 hover:border-[#7fd3ff]/50"
                        >
                            <div className="relative h-64 overflow-hidden md:h-72">
                                <img src={sigiriyaToursImage} alt="Sigiriya" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-110" />
                                <div className="absolute inset-0 bg-gradient-to-b from-transparent via-transparent to-black/60 transition-all duration-500 group-hover:to-black/80"></div>
                            </div>
                            <div className="p-6">
                                <h3 className="mb-3 text-xl font-semibold text-[#7fd3ff] transition-colors group-hover:text-white md:text-2xl">
                                    {t('famousTours.tours.sigiriyaTour.title')}
                                </h3>
                                <div className="mb-4 h-1 w-12 rounded-full bg-gradient-to-r from-[#f7d774] to-[#7fd3ff]"></div>
                                <div
                                    className="text-sm leading-relaxed text-white/80 md:text-base"
                                    dangerouslySetInnerHTML={{ __html: t('famousTours.tours.sigiriyaTour.description') }}
                                />
                                <a href="https://wa.me/94767584594?text=Hello%20Sonic%20Tours!%20I%20want%20to%20book%20a%20Sigiriya%20tour." target="_blank" rel="noopener noreferrer" className="mt-6 block">
                                    <button className="w-full cursor-pointer rounded-full bg-gradient-to-r from-[#7fd3ff] to-[#f7d774] py-2.5 font-semibold text-white transition-all group-hover:scale-105 hover:opacity-90">
                                        {t('famousTours.bookNow')}
                                    </button>
                                </a>
                            </div>
                        </motion.div>


                    </div>
                </div>
            </section>

            {/* FEATURED EXPERIENCES */}
            <motion.section initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={sectionVariants} className="py-20">
                <div className="container mx-auto px-4">
                    {/* Mobile */}
                    <div className="block space-y-24 sm:hidden">
                        {featuredExperiences.map((exp) => (
                            <div key={exp.h3} className="text-center">
                                <h2 className="font-redHatDisplay text-xl font-semibold uppercase text-[#0074D9]">{exp.h2}</h2>
                                <h3 className="font-redHatDisplay text-3xl font-bold uppercase text-white">{exp.h3}</h3>
                                {exp.h4 && <h4 className="font-redHatDisplay text-base font-medium text-[#7FDBFF]">{exp.h4}</h4>}
                                <div className="relative mt-8 h-[520px] w-full rounded-[32px] border-[4px] border-white/10 overflow-hidden shadow-2xl">
                                    <img src={exp.image} alt={exp.h3} className="h-full w-full object-cover" loading="lazy" />
                                </div>
                                <p className="mt-8 px-4 text-sm leading-7 text-white/85" dangerouslySetInnerHTML={{ __html: exp.paragraph }} />

                            </div>
                        ))}
                    </div>

                    {/* Desktop */}
                    <div className="hidden sm:block space-y-20">
                        {/* Elephant Ride */}
                        <div className="flex flex-col-reverse md:flex-row items-center justify-between">
                            <div className="relative mt-10 md:mt-0 md:w-[520px] lg:w-[700px]">
                                <img src={featuredExperiences[0].image} alt={featuredExperiences[0].h3} className="w-full rounded-[32px] border-[4px] border-white/10 shadow-2xl" loading="lazy" />
                            </div>
                            <div className="md:w-[50%] text-center md:text-right">
                                <h2 className="font-serif text-3xl font-semibold uppercase tracking-[0.02em] text-[#f7d774]">{featuredExperiences[0].h2}</h2>
                                <h3 className="font-serif text-5xl font-semibold uppercase tracking-[0.02em] text-white">{featuredExperiences[0].h3}</h3>
                                <p className="mt-6 text-lg leading-8 text-white/85" dangerouslySetInnerHTML={{ __html: featuredExperiences[0].paragraph }} />

                            </div>
                        </div>

                        {/* Perahera */}
                        <div className="flex flex-col md:flex-row items-center justify-between">
                            <div className="md:w-[50%] text-center md:text-left">
                                <h2 className="font-serif text-3xl font-semibold uppercase tracking-[0.02em] text-[#f7d774]">{featuredExperiences[1].h2}</h2>
                                <h3 className="font-serif text-5xl font-semibold uppercase tracking-[0.02em] text-white">{featuredExperiences[1].h3}</h3>
                                <h4 className="mt-2 text-2xl font-medium text-[#7fd3ff]">{featuredExperiences[1].h4}</h4>
                                <p className="mt-6 text-lg leading-8 text-white/85" dangerouslySetInnerHTML={{ __html: featuredExperiences[1].paragraph }} />

                            </div>
                            <div className="relative mt-10 md:mt-0 md:w-[520px] lg:w-[700px]">
                                <img src={featuredExperiences[1].image} alt={featuredExperiences[1].h3} className="w-full rounded-[32px] border-[4px] border-white/10 shadow-2xl" loading="lazy" />
                            </div>
                        </div>

                        {/* Safari */}
                        <div className="flex flex-col-reverse md:flex-row items-center justify-between">
                            <div className="relative mt-10 md:mt-0 md:w-[520px] lg:w-[700px]">
                                <img src={featuredExperiences[2].image} alt={featuredExperiences[2].h3} className="w-full rounded-[32px] border-[4px] border-white/10 shadow-2xl" loading="lazy" />
                            </div>
                            <div className="md:w-[50%] text-center md:text-right">
                                <h2 className="font-serif text-3xl font-semibold uppercase tracking-[0.02em] text-[#f7d774]">{featuredExperiences[2].h2}</h2>
                                <h3 className="font-serif text-5xl font-semibold uppercase tracking-[0.02em] text-white">{featuredExperiences[2].h3}</h3>
                                <p className="mt-6 text-lg leading-8 text-white/85" dangerouslySetInnerHTML={{ __html: featuredExperiences[2].paragraph }} />

                            </div>
                        </div>
                    </div>
                </div>
            </motion.section>



            {/* GUEST COMMENTS */}
            {/* <motion.section initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={sectionVariants} className="py-4">
                <div className="container mx-auto px-4 text-center">
                    <h2 className="font-konkhmer text-5xl font-bold uppercase text-[#7FDBFF]">{t('sections.reviews.title')}</h2>
                    <p className="mt-4 text-white/70">{t('sections.reviews.subtitle')}</p>
                    <div className="mt-8 flex justify-center gap-2"><div className="h-[3px] w-32 bg-[#0074D9] shadow-glow"></div><div className="h-[3px] w-32 bg-[#7FDBFF] shadow-glow"></div></div>
                    <div className="mt-14 flex justify-center">
                        <div className="elfsight-app-c71ea6ad-b325-4591-85b7-44592acd03e5 w-full max-w-5xl" data-elfsight-app-lazy style={{ minHeight: '420px' }}></div>
                    </div>
                </div>
            </motion.section> */}

            {/* OUR GALLERY SECTION */}
            <section
                id="gallery-section"
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, amount: 0.3 }}
                variants={sectionVariants}
                className="bg-gradient-to-b from-[#0b1527] via-[#07111f] to-[#0b1527] py-10"
            >
                <div className="container mx-auto px-4">
                    {/* Header */}
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.3 }}
                        variants={textVariants}
                        className="flex items-center gap-5"
                    >
                        <div className="h-px w-[40px] bg-gradient-to-r from-[#0074D9] to-transparent"></div>
                        <h1 className="font-serif text-[25px] font-semibold uppercase tracking-[0.02em] text-[#7fd3ff] md:text-[30px] lg:text-[40px]">

                            {t('gallery.title')}

                        </h1>
                    </motion.div>

                    <motion.p
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.3 }}
                        variants={textVariants}
                        className="mt-2 w-full font-medium text-white/70 lg:w-[50%] lg:text-lg font-inknut"
                    >
                        {t('gallery.subtitle')}
                    </motion.p>

                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.3 }}
                        variants={textVariants}
                        className="my-8 h-px w-full bg-gradient-to-r from-transparent via-white/20 to-transparent lg:my-14"
                    />

                    {/* Mobile Carousel */}
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.3 }}
                        variants={textVariants}
                        className="mt-5 block md:hidden"
                    >
                        <Slider {...galleryMobileSettings}>
                            {galleryImages.map((image, index) => (
                                <div key={index} className="px-2">
                                    <div className="relative h-[300px] w-full overflow-hidden rounded-lg">
                                        <img
                                            src={image.src}
                                            alt={image.alt}
                                            onClick={() => openGalleryImage(image.src, image.alt)}
                                            className="h-full w-full cursor-pointer object-cover transition-transform duration-300 hover:scale-105"
                                            onError={(e) => {
                                                e.target.src = 'https://via.placeholder.com/300x300?text=Image+Not+Found';
                                            }}
                                        />
                                    </div>
                                </div>
                            ))}
                        </Slider>
                    </motion.div>

                    {/* Tablet Grid */}
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.3 }}
                        variants={textVariants}
                        className="mt-5 hidden md:grid md:grid-cols-2 lg:hidden gap-4"
                    >
                        {galleryImages.map((image, index) => (
                            <div key={index} className="relative h-[250px] w-full overflow-hidden rounded-lg">
                                <img
                                    src={image.src}
                                    alt={image.alt}
                                    onClick={() => openGalleryImage(image.src, image.alt)}
                                    className="h-full w-full cursor-pointer object-cover transition-transform duration-300 hover:scale-105"
                                    onError={(e) => {
                                        e.target.src = 'https://via.placeholder.com/250x250?text=Image+Not+Found';
                                    }}
                                />
                            </div>
                        ))}
                    </motion.div>

                    {/* Desktop Gallery - Professional Uniform Grid */}
                    <div className="mt-8 hidden lg:grid lg:grid-cols-4 gap-6">
                        {galleryImages.map((image, index) => (
                            <div
                                key={index}
                                onClick={() => openGalleryImage(image.src, image.alt)}
                                className="group relative cursor-pointer overflow-hidden rounded-3xl border border-white/10 bg-[#0d1729] shadow-xl"
                            >
                                <div className="aspect-[4/3] overflow-hidden">
                                    <img
                                        src={image.src}
                                        alt={image.alt}
                                        className="h-full w-full object-cover transition-all duration-700 group-hover:scale-110"
                                    />
                                </div>

                                <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100"></div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* FINAL CTA */}
            <motion.section initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={sectionVariants} className="py-20">
                <div className="relative h-[65vh] md:h-[75vh] flex items-center justify-center overflow-hidden">
                    <img src={aboutContactImage} alt={t('cta.alt')} className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
                    <div className="absolute inset-0 bg-black/70 backdrop-blur-sm"></div>
                    <div className="relative z-10 text-center px-5 max-w-6xl">
                        <h1 className="font-serif text-4xl font-semibold uppercase tracking-[0.02em] text-white md:text-6xl">{t('cta.title')}</h1>
                        <p className="mx-auto mt-6 max-w-3xl text-lg text-white/90">{t('cta.desc')}</p>
                        <a href="/contact-us" className="mt-10 inline-block">
                            <button className="rounded-full bg-gradient-to-r from-[#7fd3ff] to-[#f7d774] px-10 py-5 text-xl font-bold text-white shadow-2xl transition hover:scale-105">
                                {t('cta.button')}
                            </button>
                        </a>
                    </div>
                </div>
            </motion.section>

            {selectedGalleryImage && (
                <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/85 p-4 backdrop-blur-sm" onClick={closeGalleryImage}>
                    <div className="relative w-full max-w-6xl rounded-[2rem] border border-white/10 bg-[#08111f] p-3 shadow-[0_25px_80px_rgba(0,0,0,0.45)]" onClick={(event) => event.stopPropagation()}>
                        <button
                            type="button"
                            onClick={closeGalleryImage}
                            className="absolute right-4 top-4 z-10 flex h-11 w-11 items-center justify-center rounded-full border border-white/20 bg-black/50 text-2xl text-white transition hover:bg-white/20"
                            aria-label="Close image"
                        >
                            ×
                        </button>
                        <img
                            src={selectedGalleryImage.src}
                            alt={selectedGalleryImage.alt}
                            className="max-h-[85vh] w-full rounded-[1.25rem] object-contain"
                        />
                    </div>
                </div>
            )}
        </div >
    );
};

export default Home;